module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cw-7b83329130ff6a4d69d47c376dbebc79.svg";